import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { SettingsSliderHorizontalIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

import { getIncrementsSummary } from 'components/event_type_edit'
import { useEventType } from 'features/event_type_provider'

import { TrimmedSubheader } from '../../components/styles'

export const Summary = () => {
  const eventType = useEventType()
  const { values: { slug, spotStep, customSpotStep, customSpotStepType, lockTimezoneStatus } } = useFormContext()

  const bookingPath = eventType.isShared ? null : `/${slug}`
  const step = getIncrementsSummary({ spotStep, customSpotStep, customSpotStepType })
  const increments = I18n.t('publisher.event_type_editor.sections.more_options.increments.subheader', { step })

  const timezoneLock = lockTimezoneStatus === 'locked'
    ? I18n.t('publisher.event_type_editor.sections.more_options.timezone.subheader.locked')
    : I18n.t('publisher.event_type_editor.sections.more_options.timezone.subheader.auto')

  return (
    <BodyText color={colorTextSecondary} size="medium">
      <SettingsSliderHorizontalIcon size="standard" color={colorIconSecondary} spacingRight="8" />
      <TrimmedSubheader>
        {[bookingPath, increments, timezoneLock].filter(Boolean).join(' • ')}
      </TrimmedSubheader>
    </BodyText>
  )
}
